import { useEffect } from 'react'
import { Router } from '@MTIConnect/sw-react-common'
import { useStore, useAPI } from 'global'
import RealtimeUpdater from 'components/realtimeUpdater'
import mqtt from 'components/mqtt'
import Tabbar from './tabbar'
import './styles.scss'

import Details from 'pages/storeDetails'
import Keys from 'pages/keys'
import Positions from 'pages/positions'
import Hierarchy from 'pages/storeHierarchy'
import Devices from 'pages/devices'
import SecuredProducts from 'pages/securedProducts'
import Reports from 'pages/reports'
import BLELockManager from 'pages/bleLockManager'

const { Switch, Route } = Router

export default function StoreLayout(props) {
  // This will grab the store id from the url and make sure the store context loads it in, just in
  // case a user navigates directly to this page through a link or does a hard refresh while on
  // these pages (thus, losing the in-memory selected store)
  const urlStoreID = props.storeID
  const api = useAPI()
  const { store, securityDevices, selectStore, updateSecurityDevice } = useStore()
  const listenerID = 'resourceCreated'

  useEffect(() => {
    if (store?.id != urlStoreID) selectStore(urlStoreID)
  }, [urlStoreID])

  // Listen for new devices that get added to this store
  useEffect(() => {
    if (!store) return
    mqtt.listen(listenerID, (topic, topicWithIDs, message) => {
      // Add newly created security devices to the store data
      if (topic == 'resource_created') {
        if (message.storeId != store.id) return // If the store in the message is not the current store
        if (!message.resourceType.startsWith('SecurityDevice')) return // If the resource type is not a security device
        if (securityDevices[message.resourceId]) return // If the security device is already in the store cache

        api.getSecurityDevice(message.resourceId).then(response => {
          updateSecurityDevice(response?.securityDevices?.[0])
        }).catch(()=>{})
      }
    })
    return () => mqtt.unlisten(listenerID)
  }, [store])

  return (
    <div id="store-layout-comp">
      <RealtimeUpdater />
      <Tabbar />
      <Switch>
        <Route path='details' element={Details} />
        <Route isDefault path='positions' element={Positions} />
        <Route path='zones' element={Hierarchy} />
        <Route path='devices' element={Devices} />
        <Route path='keys' element={Keys} />
        <Route path='reports' element={Reports} />
        <Route path='securedProducts' element={SecuredProducts} />
        <Route path='ble-lock-manager' element={BLELockManager} />
      </Switch>
    </div>
  )
}
